import React, { Component } from "react";
import axios from "axios";
import "./perfilEspecialista.css";

const URL_PERFIL =
  "https://institutobilinguelasnaciones.com/terapias/backend/especialistaPerfil.php";

const TIPOS_IMAGEN = ["image/jpeg", "image/png", "image/webp", "image/gif"];
const MAX_BYTES = 2 * 1024 * 1024;

const filaFormacion = () => ({ titulo: "", institucion: "", anio: "" });
const filaExperiencia = () => ({ cargo: "", lugar: "", periodo: "" });

class PerfilEspecialista extends Component {
  constructor(props) {
    super(props);
    this.inputImagen = React.createRef();
    this.state = {
      cargando: true,
      guardando: false,
      resumen: "",
      formacion: [filaFormacion()],
      experiencia: [filaExperiencia()],
      publicada: false,
      avatarUrl: "",
      mensaje: "",
      error: "",
    };
  }

  componentDidMount() {
    this.consultar();
  }

  consultar = () => {
    const cedula = (this.props.cedula || "").trim();
    if (!cedula) {
      this.setState({
        cargando: false,
        error: "No se encontró la cédula del especialista en la sesión.",
      });
      return;
    }

    const data = new FormData();
    data.append("boton", "Consultar");
    data.append("cedula", cedula);

    this.setState({ cargando: true, error: "", mensaje: "" });

    axios
      .post(URL_PERFIL, data)
      .then((res) => {
        if (!res.data || !res.data.ok) {
          this.setState({
            cargando: false,
            error: (res.data && res.data.mensaje) || "No se pudo cargar el perfil.",
          });
          return;
        }

        const formacion =
          Array.isArray(res.data.formacion) && res.data.formacion.length
            ? res.data.formacion
            : [filaFormacion()];
        const experiencia =
          Array.isArray(res.data.experiencia) && res.data.experiencia.length
            ? res.data.experiencia
            : [filaExperiencia()];

        this.setState({
          cargando: false,
          resumen: res.data.resumen || "",
          formacion,
          experiencia,
          publicada: Boolean(res.data.publicada),
          avatarUrl: res.data.avatar_url || "",
        });
      })
      .catch(() => {
        this.setState({
          cargando: false,
          error: "No se pudo conectar para cargar el perfil.",
        });
      });
  };

  onChangeResumen = (event) => {
    this.setState({ resumen: event.target.value });
  };

  actualizarLista = (lista, index, campo, valor) => {
    this.setState((state) => ({
      [lista]: state[lista].map((item, i) =>
        i === index ? { ...item, [campo]: valor } : item
      ),
    }));
  };

  agregarFila = (lista) => {
    const vacia = lista === "formacion" ? filaFormacion() : filaExperiencia();
    this.setState((state) => ({
      [lista]: state[lista].concat([vacia]),
    }));
  };

  quitarFila = (lista, index) => {
    this.setState((state) => {
      const siguiente = state[lista].filter((_, i) => i !== index);
      const vacia = lista === "formacion" ? filaFormacion() : filaExperiencia();
      return { [lista]: siguiente.length ? siguiente : [vacia] };
    });
  };

  listasParaEnviar = () => {
    const formacion = this.state.formacion
      .map((item) => ({
        titulo: (item.titulo || "").trim(),
        institucion: (item.institucion || "").trim(),
        anio: (item.anio || "").trim(),
      }))
      .filter((item) => item.titulo || item.institucion || item.anio);

    const experiencia = this.state.experiencia
      .map((item) => ({
        cargo: (item.cargo || "").trim(),
        lugar: (item.lugar || "").trim(),
        periodo: (item.periodo || "").trim(),
      }))
      .filter((item) => item.cargo || item.lugar || item.periodo);

    return { formacion, experiencia };
  };

  guardarResena = (boton) => {
    const cedula = (this.props.cedula || "").trim();
    const listas = this.listasParaEnviar();
    const data = new FormData();
    data.append("boton", boton);
    data.append("cedula", cedula);
    data.append("resumen", this.state.resumen.trim());
    data.append("formacion", JSON.stringify(listas.formacion));
    data.append("experiencia", JSON.stringify(listas.experiencia));

    this.setState({ guardando: true, mensaje: "", error: "" });

    axios
      .post(URL_PERFIL, data)
      .then((res) => {
        if (!res.data || !res.data.ok) {
          this.setState({
            guardando: false,
            error: (res.data && res.data.mensaje) || "No se pudo guardar la reseña.",
          });
          return;
        }

        this.setState({
          guardando: false,
          publicada: Boolean(res.data.publicada),
          mensaje:
            boton === "Publicar"
              ? "Reseña publicada. Los pacientes podrán verla al buscar especialistas presenciales."
              : "Reseña guardada como borrador.",
        });
      })
      .catch(() => {
        this.setState({
          guardando: false,
          error: "No se pudo conectar para guardar la reseña.",
        });
      });
  };

  elegirImagen = () => {
    if (this.inputImagen.current) {
      this.inputImagen.current.click();
    }
  };

  onImagen = (event) => {
    const file = event.target.files && event.target.files[0];
    event.target.value = "";
    if (!file) {
      return;
    }
    if (TIPOS_IMAGEN.indexOf(file.type) === -1) {
      this.setState({ error: "Usa una imagen JPG, PNG, WEBP o GIF.", mensaje: "" });
      return;
    }
    if (file.size > MAX_BYTES) {
      this.setState({ error: "La imagen no puede superar 2 MB.", mensaje: "" });
      return;
    }

    const reader = new FileReader();
    reader.onload = () => {
      const data = new FormData();
      data.append("boton", "GuardarImagen");
      data.append("cedula", (this.props.cedula || "").trim());
      data.append("imagen_base64", reader.result);

      this.setState({ guardando: true, mensaje: "", error: "" });

      axios
        .post(URL_PERFIL, data)
        .then((res) => {
          if (!res.data || !res.data.ok) {
            this.setState({
              guardando: false,
              error: (res.data && res.data.mensaje) || "No se pudo guardar la imagen.",
            });
            return;
          }
          this.setState({
            guardando: false,
            avatarUrl: res.data.avatar_url || "",
            mensaje: "Imagen de perfil actualizada.",
          });
        })
        .catch(() => {
          this.setState({
            guardando: false,
            error: "No se pudo conectar para guardar la imagen.",
          });
        });
    };
    reader.onerror = () => {
      this.setState({ error: "No se pudo leer la imagen seleccionada.", mensaje: "" });
    };
    reader.readAsDataURL(file);
  };

  quitarImagen = () => {
    const data = new FormData();
    data.append("boton", "EliminarImagen");
    data.append("cedula", (this.props.cedula || "").trim());
    this.setState({ guardando: true, mensaje: "", error: "" });

    axios
      .post(URL_PERFIL, data)
      .then((res) => {
        if (!res.data || !res.data.ok) {
          this.setState({
            guardando: false,
            error: (res.data && res.data.mensaje) || "No se pudo quitar la imagen.",
          });
          return;
        }
        this.setState({
          guardando: false,
          avatarUrl: "",
          mensaje: "Imagen eliminada.",
        });
      })
      .catch(() => {
        this.setState({
          guardando: false,
          error: "No se pudo conectar para quitar la imagen.",
        });
      });
  };

  render() {
    const { nombre } = this.props;
    const {
      cargando,
      guardando,
      resumen,
      formacion,
      experiencia,
      publicada,
      avatarUrl,
      mensaje,
      error,
    } = this.state;

    return (
      <div className="perfil-esp">
        <h2>Mi perfil</h2>
        <p className="perfil-esp-intro">
          {nombre ? nombre : "Especialista"}
          {publicada ? " · Reseña publicada" : " · Borrador"}
        </p>

        {cargando ? <p>Cargando perfil...</p> : null}

        {!cargando ? (
          <div>
            <div className="perfil-esp-foto">
              {avatarUrl ? (
                <img src={avatarUrl} alt="" className="perfil-esp-avatar" />
              ) : (
                <span className="perfil-esp-avatar perfil-esp-avatar-vacio">Foto</span>
              )}
              <div>
                <input
                  ref={this.inputImagen}
                  type="file"
                  accept="image/jpeg,image/png,image/webp,image/gif"
                  className="perfil-esp-file"
                  onChange={this.onImagen}
                />
                <button
                  type="button"
                  className="boton"
                  onClick={this.elegirImagen}
                  disabled={guardando}
                >
                  Cargar imagen
                </button>
                {avatarUrl ? (
                  <button
                    type="button"
                    className="boton"
                    onClick={this.quitarImagen}
                    disabled={guardando}
                  >
                    Quitar imagen
                  </button>
                ) : null}
                <p className="perfil-esp-nota">JPG, PNG, WEBP o GIF. Máximo 2 MB.</p>
              </div>
            </div>

            <label className="perfil-esp-campo">
              Resumen profesional
              <textarea
                rows={5}
                value={resumen}
                onChange={this.onChangeResumen}
                placeholder="Describe tu enfoque, experiencia y áreas de especialidad..."
              />
            </label>

            <div className="perfil-esp-bloque">
              <div className="perfil-esp-bloque-titulo">
                <h3>Formación</h3>
                <button type="button" className="boton" onClick={() => this.agregarFila("formacion")}>
                  + Agregar formación
                </button>
              </div>
              {formacion.map((item, index) => (
                <div className="perfil-esp-fila" key={`formacion-${index}`}>
                  <input
                    type="text"
                    placeholder="Título o certificación"
                    value={item.titulo || ""}
                    onChange={(event) =>
                      this.actualizarLista("formacion", index, "titulo", event.target.value)
                    }
                  />
                  <input
                    type="text"
                    placeholder="Institución"
                    value={item.institucion || ""}
                    onChange={(event) =>
                      this.actualizarLista("formacion", index, "institucion", event.target.value)
                    }
                  />
                  <input
                    type="text"
                    placeholder="Año"
                    value={item.anio || ""}
                    onChange={(event) =>
                      this.actualizarLista("formacion", index, "anio", event.target.value)
                    }
                  />
                  <button type="button" className="boton" onClick={() => this.quitarFila("formacion", index)}>
                    Quitar
                  </button>
                </div>
              ))}
            </div>

            <div className="perfil-esp-bloque">
              <div className="perfil-esp-bloque-titulo">
                <h3>Experiencia</h3>
                <button type="button" className="boton" onClick={() => this.agregarFila("experiencia")}>
                  + Agregar experiencia
                </button>
              </div>
              {experiencia.map((item, index) => (
                <div className="perfil-esp-fila" key={`experiencia-${index}`}>
                  <input
                    type="text"
                    placeholder="Cargo"
                    value={item.cargo || ""}
                    onChange={(event) =>
                      this.actualizarLista("experiencia", index, "cargo", event.target.value)
                    }
                  />
                  <input
                    type="text"
                    placeholder="Lugar"
                    value={item.lugar || ""}
                    onChange={(event) =>
                      this.actualizarLista("experiencia", index, "lugar", event.target.value)
                    }
                  />
                  <input
                    type="text"
                    placeholder="Periodo"
                    value={item.periodo || ""}
                    onChange={(event) =>
                      this.actualizarLista("experiencia", index, "periodo", event.target.value)
                    }
                  />
                  <button
                    type="button"
                    className="boton"
                    onClick={() => this.quitarFila("experiencia", index)}
                  >
                    Quitar
                  </button>
                </div>
              ))}
            </div>

            {error ? <p className="perfil-esp-error">{error}</p> : null}
            {mensaje ? <p className="perfil-esp-ok">{mensaje}</p> : null}

            <div className="perfil-esp-acciones">
              <button
                type="button"
                className="boton"
                disabled={guardando}
                onClick={() => this.guardarResena("Guardar")}
              >
                {guardando ? "Guardando..." : "Guardar"}
              </button>
              <button
                type="button"
                className="boton"
                disabled={guardando}
                onClick={() => this.guardarResena("Publicar")}
              >
                {guardando ? "Publicando..." : "Publicar"}
              </button>
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}

export default PerfilEspecialista;
